import { Directive, ElementRef, HostListener, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appOutsideClick]',
})
export class OutsideClickDirective implements OnInit {
  @Input() id: string;
  @Output() outsideClick: EventEmitter<any> = new EventEmitter<any>();
  constructor(private element: ElementRef) { }

  ngOnInit() {}

  @HostListener('document:click', ['$event'])
  onOutsideClick(event) {
    const toggle = document.getElementById(`share-button-toggle${this.id ? '-' + this.id : ''}`);
    if (this.element && !this.element.nativeElement.contains(event.target) && !toggle.contains(event.target)) {
      this.outsideClick.emit(false);
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeyPressed(event) {
    this.outsideClick.emit(false);
  }
}
